/* eslint-disable */
import React from 'react'
import PropTypes from 'prop-types'

function ImageComponent({
  webpSrc,
  pngSrc,
  alt,
  modeWebp = true,
  ...props
}) {
  let _webpSrc = webpSrc || String(pngSrc).replace(/(.png|.jpg|.gif)$/gi, '.webp')
  _webpSrc = String(_webpSrc).includes('.webp') ? _webpSrc : undefined
  return (
    <picture>
      <source srcSet={_webpSrc} type='image/webp' />
      <source srcSet={pngSrc} type='image/png' />
      <img src={pngSrc} alt={alt} {...props} />
    </picture>
  )
};

ImageComponent.propTypes = {
  webpSrc: PropTypes.string,
  pngSrc: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  modeWebp: PropTypes.bool
}

export default ImageComponent
